import type { Child } from '../../api/models';
import { AppText } from '../../components/AppText';
import { AppTextField } from '../../components/AppTextField';
import { InlineNotice } from '../../components/InlineNotice';
import { PrimaryButton } from '../../components/PrimaryButton';
import { Strings } from '../../strings';

import { canSubmit } from './AddChildState';
import { useAddChild } from './useAddChild';

export function AddChildScreen({ onCreated }: { onCreated: (child: Child) => void }) {
  const model = useAddChild(onCreated);

  return (
    <form
      onSubmit={(event) => {
        event.preventDefault();
        void model.submit();
      }}
      style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-4)' }}
    >
      <AppText as="h1" style="titleL">
        {Strings.actionAddChild}
      </AppText>

      {model.state.error !== null ? <InlineNotice text={model.state.error} tone="error" /> : null}

      <AppTextField label={Strings.labelNickname} value={model.state.nickname} onChange={model.nickname} />

      <AppTextField
        label={Strings.labelBirthYear}
        value={model.state.birthYear}
        onChange={model.birthYear}
        inputMode="numeric"
      />

      <AppTextField
        label={Strings.labelSchoolGrade}
        value={model.state.schoolGrade}
        onChange={model.schoolGrade}
        inputMode="numeric"
      />

      <PrimaryButton
        type="submit"
        label={model.state.isSubmitting ? Strings.actionSaving : Strings.actionSave}
        enabled={canSubmit(model.state)}
        loading={model.state.isSubmitting}
      />
    </form>
  );
}
